module.exports = __webpack_public_path__ + "static/media/3-normal.5f74087f.png";